angular.module("app").controller("GamesPageController", [
    '$scope',
    'preloadedProviders',
    'preloadedCategories',
    'preloadedFeatures',
    'casinoGameService',
    'hiddenGamesService',
    'errorHandler',
    'logger',
    'pagination',
    '$timeout',
    function ($scope, preloadedProviders, preloadedCategories, preloadedFeatures, casinoGameService, hiddenGamesService, errorHandler, logger, pagination, $timeout) {

        $scope.pagination = pagination.init(function () {
            $scope.getGames();
        });
        $scope.games = [];
        $scope.pagination.totalItems = 0;
        $scope.exportFilterOptions = {};



        $scope.isDisabled = function (p) {
            return p.totalItems == 0 ? 'disabled' : '';
        };

        function getPaginationFilter(p) {
            return {
                limit: p.limit,
                current_page: p.page,
                status:'published'
            }
        }

        $scope.filterOptions = {
            provider: null,
            category: null,
            feature: null,
        };

        $scope.volatility = {
            0: 'LOW',
            1:'MEDIUM',
            2: 'HIGH'
        }

        if (angular.isDefined($scope.filterOptions.is_mobile)) {
            $scope.filterOptions.gameType = $scope.filterOptions.is_mobile == 1 ? 'mobile' : 'desktop';
        } else {
            $scope.filterOptions.gameType = 'all'
        }

        $scope.providerList = angular.copy(preloadedProviders);
        $scope.categoryList = angular.copy(preloadedCategories);
        $scope.featureList = angular.copy(preloadedFeatures);

        $scope.getGames = function () {
            if (!!$scope.filterOptions.provider || !!$scope.filterOptions.category || !!$scope.filterOptions.feature) {
                var request = {}
                request.current_page = $scope.pagination.page;
                delete $scope.exportFilterOptions.is_mobile;
                delete $scope.exportFilterOptions.category;
                delete $scope.exportFilterOptions.provider;
                delete $scope.exportFilterOptions.feature;

                if ($scope.filterOptions.provider){
                    request.provider = $scope.filterOptions.provider;
                    $scope.exportFilterOptions.provider = $scope.filterOptions.provider;
                }
                if ($scope.filterOptions.category){
                    request.category = $scope.filterOptions.category;
                    $scope.exportFilterOptions.category = $scope.filterOptions.category;
                }
                if ($scope.filterOptions.feature){
                    request.feature = $scope.filterOptions.feature;
                    $scope.exportFilterOptions.feature = $scope.filterOptions.feature;
                }

                switch ($scope.filterOptions.gameType) {
                    case 'mobile':
                        request.is_mobile = 1;
                        $scope.exportFilterOptions.is_mobile = request.is_mobile;
                        break;
                    case 'desktop':
                        request.is_mobile = 0;
                        $scope.exportFilterOptions.is_mobile = request.is_mobile;
                        break;
                    default:

                }

                var requestData = angular.extend({}, request, getPaginationFilter($scope.pagination));

                return casinoGameService.getForReport(requestData).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.games = angular.copy(response.games).map(extractGame);
                            $scope.pagination.totalItems = parseInt(response.total_count);
                        } else {
                            errorHandler(response.message);
                        }
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                );
            } else {
                $scope.games = [];
                $scope.pagination.totalItems = 0;
            }
        };

        /**
         * Extract needed data from game response
         * @param game
         */
        function extractGame(game) {
            var categories = game.categories.reduce(reduceData, "");
            if (categories === "" ){
                categories = "Not selected";
            }
            var themes = game.themes.reduce(reduceData, "");
            if (themes === "" ){
                themes = "Not selected";
            }
            var features = game.features.reduce(reduceData, "");
            if (features === "" ){
                features = "Not selected";
            }

            return {
                name: game.name,
                external_id: game.extearnal_game_id,
                categories: categories,
                features: features,
                provider: game.provider_title || $scope.getProviderFullName(game.show_as_provider) || "Not selected",
                server_game_id: game.server_game_id,
                themes: themes,
                volatility: $scope.volatility[game.volatility]?$scope.volatility[game.volatility]:'',
                rtp: game.rtp,
                created_at: game.created_at,
            }

        }
        $scope.getProviderFullName = function (key) {
            for (var i = 0, length = $scope.providerList.length; i < length; i++) {
                if ($scope.providerList[i].id === key) {
                    return $scope.providerList[i].name;
                }
            }
        };
        function reduceData(prev, curr) {
            if (prev === "") {
                return prev + curr.title;
            } else {
                return prev + ", " + curr.title;
            }
        }
        $scope.listFilterObject = {
            action: function () {
                $scope.getGames();
            }
        };


    }
]);
